export default __webpack_public_path__ + "static/media/eye.4fc5cf86.svg";